import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
//import ImageComponent from '../../../../../../common/modules-react/gw-components-platform-react/ImageComponent/ImageComponent';
import styles from '../../../../themes/SasriaTheme/Styles/SasriaAgentSignupPageTemplate.module.scss';

function SasriaAgentSignupPageTemplate(props) {
    const { applicationName, applicationLogo, contentToRender } = props;

    return (
        <Fragment>
            <div id="sasriaAgentPageTemplate" className={styles.sasriaAgentSignupPageTemplate}>
                <div id="sasriaAgentSignupPageTemplateHeader" className={styles.sasriaAgentSignupPageTemplateHeader}>
                    
                    <h2
                        id="sasriaAgentSignupPageTemplateApplicationName"
                        className={styles.sasriaAgentSignupPageTemplateApplicationName}
                    >
                        {applicationName}
                    </h2>
                </div>
                
                <div id="sasriaAgentSignupPageTemplateContent" className={styles.sasriaAgentSignupPageTemplateContent}>
                
                    <div
                        id="sasriaAgentSignupPageContentContainer"
                        className={styles.sasriaAgentSignupPageContentContainer}
                    >
                        {contentToRender}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

SasriaAgentSignupPageTemplate.propTypes = {
    applicationName: PropTypes.string.isRequired,
    applicationLogo: PropTypes.string.isRequired,
    contentToRender: PropTypes.shape({}).isRequired
};

export default SasriaAgentSignupPageTemplate;
